import { PropsWithClassName } from "../../../models/props-with-class-name";
import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
type IconState = {
  iconSrc: string;
  value: boolean;
};

type StateIconProps = {
  iconSrc: string;
  disabled?: IconState;
  selected?: IconState;
  hovered?: IconState;
};

const StateIcon = ({
  iconSrc,
  disabled,
  selected,
  hovered,
  className,
}: PropsWithClassName<StateIconProps>) => {
  let icon = iconSrc;

  if (disabled?.value) {
    icon = disabled.iconSrc;
  }
  if (selected?.value) {
    icon = selected.iconSrc;
  }
  if (hovered?.value) {
    icon = hovered.iconSrc;
  }

  return <BaseIcon icon={icon} className={className} />;
};

export default StateIcon;
